import { create } from "zustand";

type Theme = "light" | "dark";

function getInitialTheme(): Theme {
  if (typeof window === "undefined") return "dark";
  const stored = localStorage.getItem("theme") as Theme | null;
  if (stored) return stored;
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
  return "light";
}

interface ClientState {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  imageSize: number;
  setImageSize: (size: number) => void;
  landingVideoComplete: boolean;
  setLandingVideoComplete: (complete: boolean) => void;
  isMobile: boolean;
  setIsMobile: (isMobile: boolean) => void;
}

function getInitialImageSize(): number {
  if (typeof window === "undefined") return 75;
  const stored = localStorage.getItem("image-size");
  if (stored) {
    const parsed = Number(stored);
    if (!Number.isNaN(parsed) && parsed >= 30 && parsed <= 120) return parsed;
  }
  return 75;
}

export const useClientStore = create<ClientState>((set) => ({
  sidebarOpen: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  theme: getInitialTheme(),
  setTheme: (theme) => set({ theme }),
  toggleTheme: () =>
    set((state) => ({ theme: state.theme === "dark" ? "light" : "dark" })),
  imageSize: getInitialImageSize(),
  setImageSize: (size) => {
    localStorage.setItem("image-size", String(size));
    set({ imageSize: size });
  },
  landingVideoComplete: false,
  setLandingVideoComplete: (complete) =>
    set({ landingVideoComplete: complete }),
  isMobile: false,
  setIsMobile: (isMobile) => set({ isMobile }),
}));
